import { decamelizeKeys } from 'humps';

import { AutomationDocsApplyTypes } from '~/enums/AutomationDocsApplyTypes';
import { SearchQuery } from '~/features/advanced-search/types';
import { pilot } from '~/services/serviceInstances';
import { Uuid } from '~/types/Uuid';

interface Request {
  name: string;
  content: string;
  sampleName: string;
  applyTo: AutomationDocsApplyTypes[];
  query?: SearchQuery;
}

interface Response {
  source_id: Uuid;
}

export const createSample = async ({
  name,
  sampleName,
  content,
  applyTo,
  query,
}: Request): Promise<Response> => {
  const response: Response = await pilot.post(
    '/ai-command-center/highlights/',
    decamelizeKeys({
      clause: name,
      applyTo,
      highlight: sampleName.trim(),
      content: content.trim(),
      search_query: query,
    }),
  );

  return response;
};
